import React from 'react';
import { librarianRoutes } from '../Librarian/librarianRoutes';

import SchoolDashboard from './SchoolDashboard';
import SchoolProfile from './SchoolProfile';
import OverdueBooks from './OverdueBooks';
import MyProfile from './MyProfile';
import UserList from '../Admin/Users/UserList';

/**
 * School Admin routes (role 2).
 *
 * A school admin runs a single school. Every Librarian screen is reused under a
 * `/school/...` path — the pages are automatically scoped to the admin's own
 * `library_id` (via `useActiveLibraryId`) and navigate with `useSectionBase`, so
 * they stay inside `/school`. The librarian dashboard is swapped for a
 * school-framed dashboard, and school-only screens (My School, staff management)
 * are appended. `UserList` scopes itself to this admin's school for role 2.
 */
const reusedLibrarianRoutes = librarianRoutes
  .filter((r) => r.path !== '/librarian/dashboard')
  .map((r) => ({
    path: r.path.replace('/librarian', '/school'),
    element: r.element
  }));

export const schoolRoutes = [
  { path: '/school', element: <SchoolDashboard /> },
  { path: '/school/dashboard', element: <SchoolDashboard /> },

  ...reusedLibrarianRoutes,

  // School-admin-only screens
  { path: '/school/my-school', element: <SchoolProfile /> },
  { path: '/school/users', element: <UserList /> },
  { path: '/school/librarians', element: <UserList /> },
  { path: '/school/overdue', element: <OverdueBooks /> },
  { path: '/school/my-profile', element: <MyProfile /> }
];

export default schoolRoutes;
